import { useState } from 'react';

const LAGOS_IMG = 'https://storage.readdy-site.link/project_files/1622802d-6403-484b-8db1-5ef793dcb5d3/d012adfb-f32c-41ee-82c0-b67ad8fea46f_Herstory-of-LAGOS-Magazizne-.png?v=0e5aae4afb39a216d03282ba4533ab05';
const NIGERIA_IMG = 'https://storage.readdy-site.link/project_files/1622802d-6403-484b-8db1-5ef793dcb5d3/c8472b4f-5556-4914-9a42-3b99028b6c94_Herstory-of-Nigeria--Magazine.jpeg?v=e0bccdfd3828af4b0537722777e80bac';

interface MosaicTile {
  id: number;
  src: string;
  alt: string;
  rotation: number;
  shape: 'square' | 'tall' | 'wide';
  objectPosition: string;
}

const MOSAIC_TILES: MosaicTile[] = [
  {
    id: 1,
    src: NIGERIA_IMG,
    alt: 'HerStory of Nigeria Magazine — cover',
    rotation: -2,
    shape: 'wide',
    objectPosition: 'center top',
  },
  {
    id: 2,
    src: LAGOS_IMG,
    alt: 'HerStory of Lagos Magazine — top section',
    rotation: 2,
    shape: 'tall',
    objectPosition: 'center top',
  },
  {
    id: 3,
    src: NIGERIA_IMG,
    alt: 'HerStory of Nigeria Magazine — detail',
    rotation: 3,
    shape: 'tall',
    objectPosition: 'center 30%',
  },
  {
    id: 4,
    src: LAGOS_IMG,
    alt: 'HerStory of Lagos Magazine — full spread',
    rotation: -2,
    shape: 'wide',
    objectPosition: 'center center',
  },
  {
    id: 5,
    src: NIGERIA_IMG,
    alt: 'HerStory of Nigeria Magazine — lower section',
    rotation: -3,
    shape: 'tall',
    objectPosition: 'center 60%',
  },
  {
    id: 6,
    src: LAGOS_IMG,
    alt: 'HerStory of Lagos Magazine — bottom section',
    rotation: 4,
    shape: 'wide',
    objectPosition: 'center bottom',
  },
];

interface TileProps {
  tile: MosaicTile;
  index: number;
}

function MosaicTile({ tile, index }: TileProps) {
  const [hovered, setHovered] = useState(false);

  const heightMap = {
    square: 'h-40 md:h-52',
    tall: 'h-48 md:h-64',
    wide: 'h-36 md:h-44',
  };
  const height = heightMap[tile.shape];

  return (
    <div
      className={`relative overflow-hidden cursor-pointer ${height}`}
      style={{
        transform: `rotate(${hovered ? 0 : tile.rotation}deg) scale(${hovered ? 1.04 : 1})`,
        transition: 'transform 0.4s ease, box-shadow 0.4s ease',
        borderRadius: '8px',
        border: '2px solid rgba(212,175,55,0.4)',
        boxShadow: hovered ? '0 8px 30px rgba(139, 58, 38, 0.4)' : '0 3px 12px rgba(0,0,0,0.25)',
        animationDelay: `${index * 0.15}s`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img
        src={tile.src}
        alt={tile.alt}
        className="w-full h-full object-cover"
        style={{
          objectPosition: tile.objectPosition,
          filter: hovered
            ? 'sepia(0.2) saturate(0.9) brightness(1.05) contrast(1.05)'
            : 'sepia(0.45) saturate(0.65) brightness(0.92) contrast(1.05)',
          transition: 'filter 0.5s ease',
        }}
      />
      {/* Warm terracotta overlay */}
      <div
        className="absolute inset-0 transition-opacity duration-500"
        style={{
          background: 'linear-gradient(145deg, rgba(107,42,24,0.3) 0%, rgba(139,58,38,0.15) 50%, rgba(193,80,46,0.1) 100%)',
          opacity: hovered ? 0.2 : 0.45,
        }}
      />
      {/* Gold shimmer on hover */}
      <div
        className="absolute inset-0 transition-opacity duration-500"
        style={{
          background: 'linear-gradient(135deg, rgba(212,175,55,0.2) 0%, transparent 60%)',
          opacity: hovered ? 1 : 0,
        }}
      />
    </div>
  );
}

export default function MosaicGrid() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3 w-full">
      {/* Row 1: wide tile (col-span-2) + tall + tall */}
      <div className="col-span-2">
        <MosaicTile tile={MOSAIC_TILES[0]} index={0} />
      </div>
      <div className="col-span-1">
        <MosaicTile tile={MOSAIC_TILES[1]} index={1} />
      </div>
      <div className="col-span-1">
        <MosaicTile tile={MOSAIC_TILES[2]} index={2} />
      </div>

      {/* Row 2: tall + tall + wide tile (col-span-2) */}
      <div className="col-span-1">
        <MosaicTile tile={MOSAIC_TILES[4]} index={4} />
      </div>
      <div className="col-span-1">
        <MosaicTile tile={MOSAIC_TILES[5]} index={5} />
      </div>
      <div className="col-span-2">
        <MosaicTile tile={MOSAIC_TILES[3]} index={3} />
      </div>
    </div>
  );
}
